/* LivoNest — PDP trust / specification strip
   States plainly what the piece is and how it ships. No owner-of-workshop
   claims (the store resells finished goods). */

(function () {
  const DIM_RE = /(\d{1,3}(?:[.,]\d)?)\s*(?:[×xX*]\s*(\d{1,3}(?:[.,]\d)?)(?:\s*[×xX*]\s*(\d{1,3}(?:[.,]\d)?))?\s*)?(cm|mm)\b/i;

  function init() {
    const list = document.querySelector('[data-v2-usp]');
    if (!list || list.dataset.uspReady) return;
    list.dataset.uspReady = '1';

    const title = document.querySelector('.livonest-product-v2__title');
    const line = list.querySelector('[data-v2-dim-line]');
    const value = list.querySelector('[data-v2-dim]');
    if (title && line && value) {
      const m = (title.textContent || '').match(DIM_RE);
      if (m) {
        const parts = [m[1], m[2], m[3]].filter(Boolean);
        value.textContent = parts.join(' × ') + ' ' + m[4].toLowerCase();
      } else if (window.LN_DIMS) {
        const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
        const entry = handle ? window.LN_DIMS[handle] : null;
        if (entry) value.textContent = entry.label;
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
